import $ from 'jquery';

// エリアリスト
$('.c-navi3__list').on('click', '.js-navi-item', function(e){
  e.preventDefault();
  $('.js-navi-item').removeClass('is-active');
  $(this).addClass('is-active');

  let area = $(this).data('area');

  if (area == 'all') {
    $('.js-filterItem').show();
  } else {
    $('.js-filterItem').hide();
    $('.js-filterItem[data-area=' + area + ']').show();
  }

  if ($(window).innerWidth() < 768) {
    let parents = $(this).closest('.js-navi');
    if (parents.hasClass('is-active')) {
      parents.removeClass('is-active');
    } else {
      parents.addClass('is-active');
    }

    let value = $(this).text().trim();
    $('#special_area').text(value);
  }
})

// モーダル
let scrollPosi;
  $('.c-list1').on('click', '.js-modal', function () {
    scrollPosi = $(window).scrollTop();
    return false;
  });

$('.c-list1').on('click', '.js-modalContent', function (event) {
  if (event.currentTarget !== event.target) {
    return;
  }
  $('.js-modalClose').trigger('click');
});
$('.c-list1').on('click', '.js-modalClose', function () {
  $('body').removeAttr('style');
  $('html,body').animate({ scrollTop: scrollPosi }, 0);
  $('.js-modalContent').removeClass('is-show');
});

// スムーススクロール
$('body').on('click', 'a[href^="#"]', function(){
  let adjust = $('header').innerHeight();
  let speed = 400;
  let href= $(this).attr("href");
  let target = $(href == "#" || href == "" ? 'html' : href);
  let position = target.offset().top - adjust;
  $('body,html').animate({scrollTop:position}, speed, 'swing');
  return false;
});

// blur
$('#search').on('keydown', function(e){
  if(e.key === 'Enter'){
    $('#search').blur();
  }
})

// fadein
$(function(){
  let windowWidth = $(window).width();
  if (windowWidth < 768) {
    $('.p-offices2').removeData('fadein');
    $('.p-offices2').removeClass('in-fadein');
  }
})
